import React from 'react';
import { useNavigate } from 'react-router-dom';
import { products } from '../data/products';
import ProductCard from '../components/ProductCard';
import HeroVideo from '../assets/Hero.mp4';

const Home = () => {
  const navigate = useNavigate();
  const featuredProducts = products.slice(0, 4);

  const handleViewDetails = (productId) => {
    navigate(`/product/${productId}`);
  };

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative w-full h-screen bg-black">
        <video 
          autoPlay 
          muted 
          loop 
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={HeroVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </section>

      {/* Featured Products */}
      <section className="py-24 bg-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl md:text-5xl font-elegant font-bold text-black text-center mb-20 fade-in-up">
            Featured Collection
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {featuredProducts.map((product, index) => (
              <ProductCard
                key={product.id}
                product={product}
                index={index}
                showRating={true}
                showDescription={true}
                onClick={handleViewDetails}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Svaryn Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-elegant font-bold text-black mb-12 fade-in-up">
            Why Choose Svaryn?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed mb-12 fade-in-up delay-200">
            At Svaryn, we believe in the artistry of handcrafted silver. Our commitment to quality, unique designs, and ethical sourcing sets us apart.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl shadow-md hover-lift fade-in-left delay-300">
              <div className="w-16 h-16 bg-amber-200 rounded-full flex items-center justify-center mx-auto mb-4 scale-in">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-black mb-4">Handcrafted Excellence</h3>
              <p className="text-gray-600">Each piece is meticulously crafted by skilled artisans.</p>
            </div>
            <div className="bg-gray-50 p-8 rounded-xl shadow-md hover-lift fade-in-up delay-400">
              <div className="w-16 h-16 bg-amber-200 rounded-full flex items-center justify-center mx-auto mb-4 scale-in">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-black mb-4">Premium Silver Quality</h3>
              <p className="text-gray-600">We use only the finest sterling silver for lasting beauty.</p>
            </div>
            <div className="bg-gray-50 p-8 rounded-xl shadow-md hover-lift fade-in-right delay-500">
              <div className="w-16 h-16 bg-amber-200 rounded-full flex items-center justify-center mx-auto mb-4 scale-in">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-black mb-4">Timeless Designs</h3>
              <p className="text-gray-600">Our collections blend classic elegance with modern trends.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="bg-black text-white py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-elegant font-bold mb-8 text-gold-100 fade-in-up">
            Find Your Perfect Piece
          </h2>
          <p className="text-xl text-gray-200 mb-12 max-w-3xl mx-auto leading-relaxed fade-in-up delay-200">
            Explore our full range of silver jewellery and discover a piece that truly resonates with you.
          </p>
          <button 
            onClick={() => navigate('/products')}
            className="btn-gold text-lg px-10 py-4 hover-lift fade-in-up delay-400"
          >
            View All Products
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;
